const comparisonTable = (editor) => {

    editor.BlockManager.add('comparisonTable', {
        category: 'Tables',
        label: `
          <svg width='1.2vw' height='1.2vw' viewBox="0 -52 512.00001 512" xmlns="http://www.w3.org/2000/svg"><path d="m0 113.292969h113.292969v-113.292969h-113.292969zm30.003906-83.289063h53.289063v53.289063h-53.289063zm0 0"/><path d="m149.296875 0v113.292969h362.703125v-113.292969zm332.699219 83.292969h-302.695313v-53.289063h302.695313zm0 0"/><path d="m0 260.300781h113.292969v-113.292969h-113.292969zm30.003906-83.292969h53.289063v53.289063h-53.289063zm0 0"/><path d="m149.296875 260.300781h362.703125v-113.292969h-362.703125zm30.003906-83.292969h302.695313v53.289063h-302.695313zm0 0"/><path d="m0 407.308594h113.292969v-113.296875h-113.292969zm30.003906-83.292969h53.289063v53.289063h-53.289063zm0 0"/><path d="m149.296875 407.308594h362.703125v-113.296875h-362.703125zm30.003906-83.292969h302.695313v53.289063h-302.695313zm0 0"/></svg>
          <div class="gjs-fontFamily gjs-block-label">Comparison Table</div>
          `,
        attributes: {},
        content: `
        <div class="row d-flex justify-content-center m-4">
          <div class="col-md-10 col-lg-8">
            <div class="table-responsive m-4">
              <table class="table table-striped text-successtable-border border-light">
                <thead class="border-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"><strong>Basic</strong></th>
                    <th scope="col"><strong>Standard</strong></th>
                    <th scope="col"><strong>Premium</strong></th>
                    <th scope="col"><strong>Managed</strong></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row"><strong>HDD Storage</strong></th>
                    <td><span>700 MB</span></td>
                    <td><span>1,5 GB</span></td>
                    <td><span>50 GB</span></td>
                    <td><span>up to 5T</span></i></td>
                  </tr>
                  <tr>
                    <th scope="row"><strong>Web Server</strong></th>
                    <td><i class="bi-check"></i></td>
                    <td><i class="bi-check"></i></td>
                    <td><i class="bi-check"></i></td>
                    <td><i class="bi-check"></i></td>
                  </tr>
                  <tr>
                    <th scope="row">Database</th>
                    <td><span>-</span></td>
                    <td><span>Optional</span></td>
                    <td><i class="bi-check"></i></td>
                    <td><i class="bi-check"></i></td>
                  </tr>
                  <tr>
                    <th scope="row"><strong>DNS</strong></th>
                    <td><span>-</span></td>
                    <td><span>-</span></td>
                    <td><i class="bi-check"></i></td>
                    <td><i class="bi-check"></i></td>
                  </tr>
                  <tr>
                    <th scope="row"><strong>Backups</strong></th>
                    <td><span>-</span></td>
                    <td><span>-</span></td>
                    <td><i class="bi-check"></i></td>
                    <td><i class="bi-check"></i></td>
                  </tr>
                  <tr>
                    <th scope="row"><strong>Tech Support</strong></th>
                    <td><span>None</span></td>
                    <td><span>35$/incident</span></td>
                    <td><span>15$/incident</span></td>
                    <td><span>24/7 included</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="fw-bold"><strong>Free</strong></td>
                    <td class="fw-bold"><strong>$99/mo</strong></td>
                    <td class="fw-bold"><strong>$179/mo</strong></td>
                    <td class="fw-bold"><a href><strong>Contact us</strong></a></td>
                  </tr>
                  <tr>
                    <th class=""></th>
                    <th class=""><button class="btn btn-primary shadow">Sign-up</button></th>
                    <th class=""><button class="btn btn-primary shadow">Buy Now</button></th>
                    <th class=""><button class="btn btn-primary shadow">Buy Now</button></th>
                    <th class=""></th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        `
    })
};

export default comparisonTable;